import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errMsg, tname } from "@/lib/api";

const FORM_COLOR = { W: "var(--win)", D: "var(--draw)", L: "var(--loss)" };

function Table({ g, testid, zones, showGroup }) {
  const zone = (pos) => (!zones ? "transparent" : pos <= 4 ? "var(--cyan)" : pos <= 6 ? "var(--gold)" : pos >= g.table.length - 2 ? "var(--loss)" : "transparent");
  return (
    <div className="panel overflow-x-auto">
      {showGroup && g.group && <div className="px-4 pt-4 font-display text-xl font-bold uppercase">{g.group.replace(/_/g, " ")}</div>}
      <table data-testid={testid} className="w-full text-sm">
        <thead>
          <tr className="text-slate-400 text-xs uppercase tracking-wider border-b border-slate-800">
            {["#", "Squadra", "G", "V", "N", "P", "GF", "GS", "DR", "Forma", "Pt"].map((h) => (
              <th key={h} className={`py-3 px-3 font-semibold ${h === "Squadra" ? "text-left" : "text-center"}`}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {g.table.map((r) => (
            <tr key={r.team.id} data-testid={`standings-row-${r.position}`} className="border-b border-slate-800/60 hover:bg-slate-800/40 transition-colors">
              <td className="py-3 px-3 text-center font-mono" style={{ boxShadow: `inset 3px 0 0 ${zone(r.position)}` }}>{r.position}</td>
              <td className="py-3 px-3"><div className="flex items-center gap-3"><img src={r.team.crest} alt="" className="w-6 h-6 object-contain" /><span className="font-medium whitespace-nowrap">{tname(r.team)}</span></div></td>
              {[r.playedGames, r.won, r.draw, r.lost, r.goalsFor, r.goalsAgainst, r.goalDifference].map((v, i) => (
                <td key={i} className="py-3 px-3 text-center font-mono text-slate-300">{v}</td>
              ))}
              <td className="py-3 px-3"><div className="flex gap-1 justify-center">
                {(r.form || "").split(",").filter(Boolean).map((f, i) => <span key={i} className="w-2.5 h-2.5 rounded-full" style={{ background: FORM_COLOR[f] }} />)}
                {!r.form && <span className="text-slate-600">—</span>}
              </div></td>
              <td className="py-3 px-3 text-center font-display text-xl font-bold text-[var(--gold)]">{r.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Standings({ competition }) {
  const [groups, setGroups] = useState(null);
  useEffect(() => {
    setGroups(null);
    http.get("/public/standings", { params: { competition: competition.code } }).then((r) => setGroups(r.data)).catch((e) => { toast.error(errMsg(e)); setGroups([]); });
  }, [competition.code]);

  const league = competition.type === "LEAGUE";
  return (
    <div className="space-y-6">
      <div>
        <span className="font-mono text-xs text-slate-400 tracking-widest uppercase">{competition.area}</span>
        <h2 className="font-display text-4xl font-extrabold uppercase">Classifica {competition.name}</h2>
      </div>
      {!groups && <div className="panel h-64 scan" />}
      {groups && groups.length === 0 && <p data-testid="no-standings" className="text-slate-400">Classifica non disponibile per questa competizione.</p>}
      <div className={`grid gap-6 ${groups && groups.length > 1 ? "lg:grid-cols-2" : ""}`}>
        {groups?.map((g, i) => <Table key={g.group || i} g={g} zones={league} showGroup={groups.length > 1} testid={i === 0 ? "standings-table" : `standings-table-${i}`} />)}
      </div>
      {league && (
        <div className="flex flex-wrap gap-6 text-xs text-slate-400">
          <span className="flex items-center gap-2"><i className="w-3 h-3 bg-[var(--cyan)] inline-block" /> Zona Champions</span>
          <span className="flex items-center gap-2"><i className="w-3 h-3 bg-[var(--gold)] inline-block" /> Zona Europa</span>
          <span className="flex items-center gap-2"><i className="w-3 h-3 bg-[var(--loss)] inline-block" /> Retrocessione</span>
        </div>
      )}
    </div>
  );
}
